module.exports = __webpack_public_path__ + "static/googleIcon-f863aef4d15f1498abe6f2d498cdc987.png";